module.exports = __webpack_public_path__ + "media/images/shorts-xing-a9eeb750eff570b88d8fabe454efbb18.svg";